import { render, staticRenderFns } from "./ParcelsCustomersList.vue?vue&type=template&id=751d00fe&scoped=true&"
import script from "./ParcelsCustomersList.vue?vue&type=script&lang=js&"
export * from "./ParcelsCustomersList.vue?vue&type=script&lang=js&"
import style0 from "./ParcelsCustomersList.vue?vue&type=style&index=0&id=751d00fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751d00fe",
  null
  
)

export default component.exports